import React from "react";

// The approved Blackbox mark (attix-design-sg/wealth-series-logos,
// blackbox-icon). Like DashboardIcon it sets no fill, so the nav colours
// it through `.icon > svg { fill: var(--menu-icon) }`.
const BlackBoxIcon = ({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        transform="translate(3.26 2) scale(0.2)"
        d="M0 76.45L40.96 100V79.2L19.66 66.62V40.33L0 28.32Z M87.37 76.45V28.32L67.72 40.33V66.62L46.42 79.2V100Z M43.69 0L2.7 23.57L22.32 35.56L43.69 22.94L65.05 35.56L84.68 23.57Z"
      />
    </svg>
  );
};

export default BlackBoxIcon;
